/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnected1Inputs */

const en_crosspostingconnected1 = /** @type {(inputs: Crosspostingconnected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

const de_crosspostingconnected1 = /** @type {(inputs: Crosspostingconnected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbunden`)
};

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Crosspostingconnected1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnected1 = /** @type {((inputs?: Crosspostingconnected1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnected1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnected1(inputs)
	return de_crosspostingconnected1(inputs)
});
export { crosspostingconnected1 as "crosspostingConnected" }